import { useState, type FormEvent } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg"></i>
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 whitespace-nowrap">
            黑料学生
          </h1>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <form
            onSubmit={handleSearch}
            className="hidden items-center gap-2 rounded-md border border-background-300/70 bg-background-100 px-3 py-2 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜爆料关键词"
              className="w-24 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 xl:w-40"
            />
          </form>

          <a
            href="#subscribe"
            className="hidden cursor-pointer items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex whitespace-nowrap"
          >
            <i className="ri-megaphone-line"></i>
            我要爆料
          </a>

          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="打开导航菜单"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-700 lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}